import * as React from 'react';
import { useState, useEffect } from 'react';
import { injectIntl, InjectedIntlProps, defineMessages } from 'react-intl';
import { get as getDatabase, IDatabase, format, getAnalyticsToken, IDatabaseField } from '../../services/database';
import { get as getAttachment, IAttachment } from '../../services/attachment';
import { get as getPage, getOrganization, IPage } from '../../services/pages';
import { History } from 'history';
import Linkify from 'react-linkify';
import ReactGA from 'react-ga';
import { IOrganization } from 'src/services/account';
import { getFormattedPageData, getSepcialPageFieldKeysForDataabse } from 'src/helpers/pages';
import pdf from '../../images/pdf.png';
import doc from '../../images/doc.png';
import eps from '../../images/eps.png';
import gif from '../../images/gif.png';
import jpg from '../../images/jpg.png';
import psd from '../../images/psd.png';
import xls from '../../images/xls.png';

interface Props {
    page: IPage | null,
    database: IDatabase,
    organization: IOrganization | null,
    attachments: IAttachment[] | null
}
export default ({ page, database, organization, attachments }: Props) => {

    if (!page) return null;
    const specialSections: any = getSepcialPageFieldKeysForDataabse(database)
    const specialSectionKeys = Object.values(specialSections)

    const renderList = (list: string[], databaseField: IDatabaseField) => {
        return <ul>{list.sort((a, b) => Array.isArray(databaseField.options) ? databaseField.options.indexOf(a) - databaseField.options.indexOf(b) : 0).map((item: string) => <li key={item}>{item}</li>)}</ul>;
    }

    const dataToRender: any = getFormattedPageData(page, database)

    const totalLines = Object.keys(dataToRender).reduce((p, c) => p += specialSectionKeys.includes(c) ? 0 : dataToRender[c].lines, 0)
    const targetLines = Math.floor(totalLines / 2)
    const rightColData = {}
    const leftColData = {}
    let count = 0

    Object.keys(dataToRender).forEach(d => {
        if (specialSectionKeys.includes(d)) return
        if (count < targetLines) {
            leftColData[d] = dataToRender[d]
        } else {
            rightColData[d] = dataToRender[d]
        }
        count += dataToRender[d].lines
    })

    const renderRegularField = (key: string) => {
        if (specialSectionKeys.includes(key)) return null
        const field = dataToRender[key]
        return (
            <div className="entry-item" key={key}>
                <h6>{field.label}</h6>
                <Linkify>
                    {Array.isArray(field.value) ? renderList(field.value, field.dbField) : <p>{field.value}</p>}
                </Linkify>
            </div>
        )
    }

    const renderGoogleMapLink = (data: any) => {
        let term = ''

        term += encodeURI(data[specialSections.street]?.value)
        term += encodeURI(' ' + data[specialSections.city]?.value)
        term += encodeURI(' ' + data[specialSections.state]?.value)
        term += encodeURI(' ' + data[specialSections.zip]?.value)

        return 'https://maps.google.com/?q=' + term
    }

    const getFileType = (name: string) => {
        const type = (name.split('.').pop() || '').toLocaleLowerCase();
        switch (type) {
            case 'pdf':
                return pdf;
            case 'ppt':
                return doc;
            case 'docx':
                return doc;
            case 'doc':
                return doc;
            case 'png':
                return doc;
            case 'jpg':
                return jpg;
            case 'jpeg':
                return jpg;
            case 'eps':
                return eps;
            case 'gif':
                return gif;
            case 'psd':
                return psd;
            case 'xls':
                return xls;
            case 'xlsx':
                return xls;
            case 'psd':
                return psd;
            default:
                return doc;
        }
    };

    const renderAttachment = (attachment: IAttachment) => (
        <li className="col-sm-6 col-md-4 col-lg-3 py-3">
            <a href={attachment.url} className="attachment-link" target="_blank">
                <div className="attachment-module">
                    <img src={getFileType(attachment.fileName)} className="pb-3" />
                    <p>{attachment.fileName}</p>
                </div>
            </a>
        </li>)

    return (
        <>
            <section id="hero" className="py-5">
                <div className="container">
                    <div className="row d-flex align-items-center">
                        <div className="col-md-2 text-center"><img src={organization?.avatar} className="logo img-fluid" /></div>
                        <div className="col">
                            <h1 className="program-title">{page?.title}</h1>
                            <h3 className="organization-name">{organization?.orgName}</h3>
                        </div>
                    </div>
                </div>
            </section>
            <section id="overview" className="py-5">
                <div className="container">
                    <div className="row">
                        <div className="col program-info">
                            <div className="program-description">
                                <h4>Program Description</h4>
                                <p>{dataToRender[specialSections.description]?.value}</p>
                                <div className="program-details">
                                    <div className="row">
                                        <div className="col-sm-6 pb-4">
                                            {Object.keys(leftColData).map(renderRegularField)}
                                        </div>
                                        <div className="col-sm-6 pb-4">
                                            {Object.keys(rightColData).map(renderRegularField)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {(dataToRender[specialSections.contact]?.value || dataToRender[specialSections.contactLast]?.value || dataToRender[specialSections.number]?.value || dataToRender[specialSections.email]?.value || dataToRender[specialSections.street]?.value || dataToRender[specialSections.link]?.value) &&
                            <div className="col-md-4 col-lg-3 contact-info">
                                <div className="info-box">
                                    {!!dataToRender[specialSections.contact]?.value && <div className="program-contact-name entry-item">
                                        <h6>Program Contact Name</h6>
                                        <p>{dataToRender[specialSections.contact]?.value}</p>
                                    </div>}
                                    {!!dataToRender[specialSections.contactLast]?.value && <div className="program-contact-name entry-item">
                                        <h6>Program Contact Name</h6>
                                        <p>{dataToRender[specialSections.contactFirst]?.value}{' '}{dataToRender[specialSections.contactLast]?.value}</p>
                                    </div>}
                                    {!!dataToRender[specialSections.number]?.value && <div className="program-contact-phone entry-item">
                                        <h6>Program Contact Phone</h6>
                                        <p>{dataToRender[specialSections.number]?.value}</p>
                                    </div>}
                                    {!!dataToRender[specialSections.email]?.value && <div className="program-email entry-item">
                                        <h6>Program Contact Email</h6>
                                        <p><a style={{ overflowWrap: "break-word" }} href={`mailto:${dataToRender[specialSections.email]?.value}`}>{dataToRender[specialSections.email]?.value}</a></p>
                                    </div>}
                                    {!!dataToRender[specialSections.street]?.value && <div className="address entry-item">
                                        <h6>Program Address</h6>
                                        <a href={renderGoogleMapLink(dataToRender)}  >
                                            <p className="program-address">{dataToRender[specialSections.street]?.value}</p>
                                            <p><span className="city">{dataToRender[specialSections.city]?.value}</span>, <span className="state">{dataToRender[specialSections.state]?.value}</span> <span className="zip-code">{dataToRender[specialSections.zip]?.value}</span></p>
                                        </a>
                                    </div>}
                                    {!!dataToRender[specialSections.link]?.value && <div className="program-website entry-item">
                                        <h6>Organization Website/Program Link</h6>
                                        <p style={{ overflowWrap: "break-word" }}><Linkify>{dataToRender[specialSections.link]?.value}</Linkify></p>
                                    </div>}
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </section>
            {!!attachments?.length && <section id="attachments" className="py-5">
                <div className="container">
                    <h4>Attachments</h4>
                    <ul className="pdf-list row pt-3">
                        {attachments?.map(renderAttachment)}
                    </ul>
                </div>
            </section>}
        </>
    )
}


// WEBPACK FOOTER //
// ./src/public/pages/ColumnTemplate.tsx